import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import EditUserInfo from '../editUserInfo/userInfoForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class UpdateUserInfo extends Component {
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} isApprovedUser/>,
                id: 0,
            }, {
                title: 'Update Info',
                content: <EditUserInfo />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default UpdateUserInfo